import { Address } from '@dehaat/kisan-app-bl/models/AddressV2'
import { ORDER_TYPE } from '@dehaat/kisan-app-bl/models/Order'
import { Vendor } from '@dehaat/kisan-app-bl/models/Vendor'
import { ProductVariant } from 'src/models/Product'
import { CartStateInStorage } from 'src/models/Product'

import { CART_TYPE } from '@/constants/cart'
import { MY_CART } from '@/constants/common'
import { AvailableCoupon } from '@/models/Coupon'

import { getLocalStorageKey } from './helper'
import { buildProductOrderDetailLine } from './helpers/flashSale'
export const createCouponQuery = (
  isPickupOrder: boolean,
  orderCreatedFor: string,
  cartList: ProductVariant[],
  totalVariantCost: number,
  totalInsuranceCost: number,
  totalDiscount: number,
  shippingCharges: number,
  appliedCoupon: AvailableCoupon,
  cartItems: Record<string, number>,
  selectedAddress: Address | null,
  vendor: Vendor,
) => {
  const cartData = getLocalStorageKey<CartStateInStorage, null>(MY_CART, null)
  const cartId = cartData?.[CART_TYPE.DEHAAT].cartId|| ''
  const catalogueIds = cartData?.[CART_TYPE.DEHAAT].catalogueIds || {}

  const totalPrice = totalVariantCost + totalInsuranceCost - totalDiscount + shippingCharges

  const query: any = {
    type: isPickupOrder ? ORDER_TYPE.SELF_PICKUP : ORDER_TYPE.DOORSTEP,
    delivery_fee: shippingCharges.toFixed(2),
    vendor: vendor?.id,
    price: (totalVariantCost + totalInsuranceCost).toFixed(2),
    discount: totalDiscount.toFixed(2),
    total_price: totalPrice.toFixed(2).toString(),
    cart_id: cartId,
    order_created_for: orderCreatedFor,

    order_details: cartList.map((variant) => {
      const catalogueId = catalogueIds[variant.id]
      const qty = cartItems[variant.id] as number
      return buildProductOrderDetailLine({
        variant,
        quantity: qty,
        catalogueId,
      })
    }),
  }

  if (!isPickupOrder) {
    query.address = selectedAddress?.id
    query.full_display_address = selectedAddress?.full_display_address
  }

  if (appliedCoupon) {
    query.coupon = {
      code: appliedCoupon.couponCode,
      discount: appliedCoupon.discount ?? '',
    }
    query.total_price = (
      Number(totalPrice) - Number(appliedCoupon.discount ?? 0)
    ).toFixed(2)
  }

  return query
}
